module.exports = __webpack_public_path__ + "img/yangrui.618d2dbc.jpg";